module.exports = __webpack_public_path__ + "img/water_meter.b3dd4e54.svg";